module.exports = __webpack_public_path__ + "static/media/22.6f7aacc9.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/hairback/22.png
// module id = 660
// module chunks = 0